import script from "./main_page.vue?vue&type=script&setup=true&lang=js"
export * from "./main_page.vue?vue&type=script&setup=true&lang=js"

import "./main_page.vue?vue&type=style&index=0&id=c1224bc4&lang=css"

const __exports__ = script;

export default __exports__